import { Grid } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { FormSection } from "components/FormControls/FormSection";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { TextInput } from "components/FormControls/TextInput";
import { Toggle } from "components/FormControls/Toggle";
import { useMessage } from "hooks/intl";

export const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    title: {
      fontSize: "16px",
      fontWeight: 500,
      color: "#222",
    },
  }),
);

interface Props {
  showAddressDetails: boolean;
}

export const CompanyDetails = ({ showAddressDetails }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <FormSection>
      <Grid container rowSpacing={12} columnSpacing={16}>
        <Grid item xs={12}>
          <div className={classes.wrapper}>
            <span className={classes.title}>
              {message({ id: "companyDetails" })}
            </span>
            <Toggle
              name="companyDetails"
              data-test-id="member-company-details"
            />
          </div>
        </Grid>
        {showAddressDetails && (
          <>
            <Grid item xs={6}>
              <TextInput
                label={
                  <RequiredFieldLabel text={message({ id: "companyName" })} />
                }
                name="company.name"
                data-test-id="member-company-name"
                width="100%"
                data-hj-suppress
              />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                label={
                  <RequiredFieldLabel
                    text={message({
                      id: "taxIdentificationNumber",
                    })}
                  />
                }
                name="company.nip"
                data-test-id="member-company-nip"
                width="100%"
                data-hj-suppress
              />
            </Grid>
          </>
        )}
      </Grid>
    </FormSection>
  );
};
